import React, {FC} from 'react';
import {Helmet} from 'react-helmet';
import {useTranslation} from 'react-i18next';
import { Mineralfertilizersuppliers } from '../../components/chemistry/Mineralfertilizersuppliers';

const Mineralfertilizersupplierspage: FC = () => {
    const {t} = useTranslation();

    return (
        <>
            <Helmet>
                <title>Поставщики минеральных удобрений</title>
            </Helmet>
            <Mineralfertilizersuppliers/>
        
        </>
    );
};

export default Mineralfertilizersupplierspage
